import React from 'react';
import { withContainer } from 'core/cache';

import ChallengeModal from '../components/challengeModal';
import { getMockChallenges } from '../helpers/getMockData';

class ChallengeModalContainer extends React.Component {
  render() {
    const { challengeModal, gamification } = this.props;

    return (
      <ChallengeModal
        challenge={challengeModal.data}
        gamification={gamification.data}
        isLoading={challengeModal.status !== 'success'}
      />
    );
  }
}

export default withContainer(ChallengeModalContainer, {
  cache: {
    challengeModal: {
      getMockedResponse: () => ({ data: getMockChallenges().completed[0] }),
      getParams: ({ props }) => ({ id: props.id }),
      initialData: {},
      isMocked: false,
      transform: ({ data }) => data.data,
      url: '/api/learner/challenges/:id',
    },
    gamification: { isListener: true },
  },
});
